import StagesEnum from '../../../enums/editions/stages.enum';

class SaveOpenedStagesDto {
  stage!: StagesEnum;
  opened!: boolean;
}

export default SaveOpenedStagesDto;
